import { FaqList } from "../components/FaqList";
import { PageFrame } from "../components/PageFrame";
import { Reveal } from "../components/Reveal";

export function FaqPage() {
  return (
    <PageFrame
      className="faq-page"
      label="ΑΣΟ ΩΜΕΓΑ"
      title="Ερωτήσεις"
      intro={<p>Όσα χρειάζεται να γνωρίζετε για την εγγραφή και την προπόνηση.</p>}
    >
      <Reveal className="faq-panel technical-frame">
        <FaqList initialOpen={0} />
      </Reveal>
    </PageFrame>
  );
}
